import { Box } from '@rebass/grid';

import { Heading6, Image } from 'app/shared/ui';

import * as Styled from './index.css';
import { TItem } from './types';

export const Item = ({
  iconPath,
  iconAltText,
  heading,
  children,
}: TItem): JSX.Element => (
  <Styled.Container>
    <Box mb={16}>
      <Image size="64px" alt={iconAltText} src={`/assets/${iconPath}`} />
    </Box>

    <Box mb={16}>
      <Heading6 fontSize={[16]} lineHeight={[1.33]}>
        {heading}
      </Heading6>
    </Box>

    {children}
  </Styled.Container>
);
